import { Children } from 'react';

const getChildInstanceOf = (Child, children) =>
  Children.toArray(children).find(({ type }) => type === Child);

export default getChildInstanceOf;
